module.exports = __webpack_public_path__ + "img/IMG_7235.8f587db6.webp";